import React from 'react';

import { ReactComponent as GooglePlayIcon } from '../../../assets/appStore/googlePlay.svg';
import { ReactComponent as AppleStoreIcon } from '../../../assets/appStore/appleStore.svg';

export const DownloadApp = () => {
   return (
      <div className='download-app-container'>
         <p className='appstore'>ดาวน์โหลดแอปสำหรับอ่านบนอุปกรณ์ของคุณ</p>
         <div>
            <a
               href={`https://apps.apple.com/app/hytexts-com-ebook-store/id908903530`}
               target='_blank'
               rel='noopener noreferrer'
            >
               <AppleStoreIcon />
            </a>
            <a
               href={`https://play.google.com/store/apps/details?id=com.IPJ1988.hytexts.ebookstore`}
               target='_blank'
               rel='noopener noreferrer'
            >
               <GooglePlayIcon />
            </a>
         </div>
      </div>
   );
};
